import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { toVault77ApiError } from "../../core/apiError";
import { HEALTH_ENDPOINT } from "./constants";
import type { Vault77HealthFilters, Vault77HealthReport } from "../types";

/**
 * Fetch the Vault77 data-quality ("health") report for the active employee roster.
 * GET api/vault77/health  (optional ?departmentId= scopes to one department; omitted = all active).
 *
 * The server composes the roster (from FieldResponse2_1) with the Vault77 scan and returns only
 * employees that have at least one finding, plus roll-up counts.
 */
export async function getEmployeeHealth(
    filters?: Vault77HealthFilters
): Promise<Vault77HealthReport> {
    try {
        let url = HEALTH_ENDPOINT;
        if (filters && filters.departmentId != null) {
            url = `${url}?departmentId=${encodeURIComponent(String(filters.departmentId))}`;
        }
        const response = await Axios.get<Vault77HealthReport>(url, AxiosConfig.configValue("min"));
        return response.data;
    } catch (error) {
        console.error("getEmployeeHealth/api ~ error:", error);
        throw toVault77ApiError(error, "Unable to load the Vault77 health report.");
    }
}
